module.exports = __webpack_public_path__ + "static/media/MAYANS_Kilian_+Z.685e89b1.svg";